import {gql} from '@apollo/client';

export const VERIFY_ACCOUNT = gql`
    mutation verifyAccount($input: VerifyAccountInput!){
        verifyAccount(input: $input){
            jwt
            user{
                _id
                role
                email
                firstName
                lastName
                avatarUrl
                isSeller
                paymentSetupComplete
            }
        }
    }
`